export class Commission {

    public static isCommissionValid(commission: Commission): boolean {
        return commission.libelle != null && commission.libelle.trim().length > 0 &&
            commission.dateLimiteAvis != null && commission.heureLimiteAvis != null &&
            commission.dateCommission != null && commission.heureCommission != null &&
            commission.datePublication != null && commission.heurePublication != null;
    }

    constructor(
        public id?: number,
        public libelle?: string,
        public dateCommission?: any,
        public heureCommission?: any,
        public datePublication?: any,
        public heurePublication?: any,
        public dateCoupure?: any,
        public heureCoupure?: any,
        public dateLimiteAvis?: any,
        public heureLimiteAvis?: any,
        public campagnes?: any[],
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission.model.ts